"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCommonPageActionsApi = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("react");
var _sliReactMetrics = require("@cvent/sli-react-metrics");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * ------------------------------------------------------------------------------------
                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * This client was automatically generated. ** Do Not Edit **
                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * ------------------------------------------------------------------------------------
                                                                                                                                                                                                                                                                                                                                                                                                                                                                          */
/**
 * This hook exposes a typed api with functions from the application's tracking plan.
 * Internally, each function uses the usePageActions API to track actions and forward
 * them to the reporters that were installed during the Metrics initialization in your
 * application's main entry point component.
 *
 * Note: This is the recommended way of tracking/measuring actions as it allows you to
 * register base properties during the metrics' client initialization, which will be included
 * automatically to every action whenever they are executed by your instrumentation code
 *
 *
 * How to use it:
 *
 * `const { acqSignupCompleted } = useCommonPageActionsApi();`
 *
 *  // Somewhere in your application you can use this function to track this action
 * `acqSignupCompleted({ userId, email, accountName });`
 *
 * // If you want to track this action as an error you can do it with this piece of code below
 *  `acqSignupCompleted({ userId, email, error: '500 Error........' });`
 *
 * // If you want to track this action as an expected error you can do it with this piece of code below
 *  `acqSignupCompleted({ userId, email, expected_error: 'This email address is already associated with an existing account.' });`
 *
 * @returns AnalyticsApi
 */
var useCommonPageActionsApi = exports.useCommonPageActionsApi = function useCommonPageActionsApi() {
  var measureActionsAttributesRef = (0, _react.useRef)({});
  var _usePageActions = (0, _sliReactMetrics.usePageActions)(),
    startAction = _usePageActions.startAction,
    endAction = _usePageActions.endAction,
    trackAction = _usePageActions.trackAction,
    getBaseProps = _usePageActions.getBaseProps;
  var _ref = getBaseProps() || {},
    trackingPlanName = _ref.trackingPlanName;
  /**
   * this action tracks the users who upload a custom background in order to understand how many users are creating custom backgrounds
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMepZgdlXMWD3ORK2EJCYaAKd
   * name          : studio background uploaded
   * downstreamName: background uploaded
   * owner         : vikings
   * phase         : activation
   * release       : v2.0
   * version       : 1-0-0
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the user uploads a background image locally and clicks the save button in the upload background modal
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {BackgroundUploaded} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  var backgroundUploaded = (0, _react.useCallback)(function (props, options) {
    // Grab the destinations from the definition so the rudderstack reporter configures
    // the integrations accordingly
    var destinations = 'datadog,Mixpanel,Snowflake,Intercom'.split(',');
    // RudderStack unique action name for the workspace
    var action = _objectSpread({
      id: 'studio background uploaded'
    }, destinations && {
      destinations: destinations
    });
    var metadata = JSON.parse('{}');
    var hasMetadata = Object.keys(metadata).length > 0;
    // Track action via the pageActions API
    trackAction(action, _objectSpread(_objectSpread(_objectSpread({}, props), getBaseProps()), {}, {
      version: '1-0-0',
      downstreamName: 'background uploaded'
    }), _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active',
      metadata: hasMetadata ? metadata : undefined
    }));
  }, [getBaseProps, trackAction]);
  /**
   * this action measures the time taken in uploading a background image on the stage
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMeo3UKYzw6h6uQbxEOi7hPsD
   * name          : studio background uploaded on stage
   * downstreamName: background uploaded on stage
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       : 1-0-0
   * type          : measure
   * multiStep     :  no
   * trigger       : the measurement starts when the user clicks the save button in the upload background modal and ends when the image uploads on the stage
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {BackgroundUploadedOnStage} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  var startBackgroundUploadedOnStage = (0, _react.useCallback)(function (props, options, callback) {
    var destinations = 'datadog,Mixpanel,Snowflake,Intercom'.split(',');
    // RudderStack unique action name for the workspace
    var action = _objectSpread({
      id: 'studio background uploaded on stage'
    }, destinations && {
      destinations: destinations
    });
    measureActionsAttributesRef.current[action.id] = props;
    var metadata = JSON.parse('{}');
    var hasMetadata = Object.keys(metadata).length > 0;
    // Start measuring action via the pageActions API
    startAction(action, _objectSpread(_objectSpread({}, props), {}, {
      version: '1-0-0',
      downstreamName: 'background uploaded on stage'
    }), callback, _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active',
      metadata: hasMetadata ? metadata : undefined
    }));
  }, [startAction]);
  /**
   * Records action the measurement starts when the user clicks the save button in the upload background modal and ends when the image uploads on the stage
   */
  var endBackgroundUploadedOnStage = (0, _react.useCallback)(function (props, options) {
    var actionId = 'studio background uploaded on stage';
    // Record action via the pageActions API
    endAction(actionId, _objectSpread(_objectSpread(_objectSpread({}, props), getBaseProps()), {}, {
      version: '1-0-0',
      downstreamName: 'background uploaded on stage'
    }), false, _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active'
    }));
  }, [getBaseProps, endAction]);
  /**
   * This action tracks the users who change their camera in order to use different camera source.
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio camera changed
   * downstreamName: camera changed
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the user toggles their Camera
   * destinations  : datadog,Mixpanel,Snowflake
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {CameraChanged} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  var cameraChanged = (0, _react.useCallback)(function (props, options) {
    // Grab the destinations from the definition so the rudderstack reporter configures
    // the integrations accordingly
    var destinations = 'datadog,Mixpanel,Snowflake'.split(',');
    // RudderStack unique action name for the workspace
    var action = _objectSpread({
      id: 'studio camera changed'
    }, destinations && {
      destinations: destinations
    });
    var metadata = JSON.parse('{}');
    var hasMetadata = Object.keys(metadata).length > 0;
    // Track action via the pageActions API
    trackAction(action, _objectSpread(_objectSpread(_objectSpread({}, props), getBaseProps()), {}, {
      version: '',
      downstreamName: 'camera changed'
    }), _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active',
      metadata: hasMetadata ? metadata : undefined
    }));
  }, [getBaseProps, trackAction]);
  /**
   * This action measures the time taken in toggling the speaker's camera on or off to understand responsiveness and user behavior.
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio camera toggled
   * downstreamName: camera toggled
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : measure
   * multiStep     :  no
   * trigger       : the measurement starts when the speaker clicks the Start/Stop video button to toggle their camera, and ends when the camera state change (on/off) is completed and reflected in the UI
   * destinations  : datadog,Mixpanel,Snowflake
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {CameraToggled} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  var startCameraToggled = (0, _react.useCallback)(function (props, options, callback) {
    var destinations = 'datadog,Mixpanel,Snowflake'.split(',');
    // RudderStack unique action name for the workspace
    var action = _objectSpread({
      id: 'studio camera toggled'
    }, destinations && {
      destinations: destinations
    });
    measureActionsAttributesRef.current[action.id] = props;
    var metadata = JSON.parse('{}');
    var hasMetadata = Object.keys(metadata).length > 0;
    // Start measuring action via the pageActions API
    startAction(action, _objectSpread(_objectSpread({}, props), {}, {
      version: '',
      downstreamName: 'camera toggled'
    }), callback, _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active',
      metadata: hasMetadata ? metadata : undefined
    }));
  }, [startAction]);
  /**
   * Records action the measurement starts when the speaker clicks the Start/Stop video button to toggle their camera, and ends when the camera state change (on/off) is completed and reflected in the UI
   */
  var endCameraToggled = (0, _react.useCallback)(function (props, options) {
    var actionId = 'studio camera toggled';
    // Record action via the pageActions API
    endAction(actionId, _objectSpread(_objectSpread(_objectSpread({}, props), getBaseProps()), {}, {
      version: '',
      downstreamName: 'camera toggled'
    }), false, _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active'
    }));
  }, [getBaseProps, endAction]);
  /**
   * this action tracks the users who send messages using embedded chat in order to better understand chat usage
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio chat message sent
   * downstreamName: chat message sent
   * owner         : vikings
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when a user sends a message in embedded chat
   * destinations  : datadog,Mixpanel
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {ChatMessageSent} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  var chatMessageSent = (0, _react.useCallback)(function (props, options) {
    // Grab the destinations from the definition so the rudderstack reporter configures
    // the integrations accordingly
    var destinations = 'datadog,Mixpanel'.split(',');
    // RudderStack unique action name for the workspace
    var action = _objectSpread({
      id: 'studio chat message sent'
    }, destinations && {
      destinations: destinations
    });
    var metadata = JSON.parse('{}');
    var hasMetadata = Object.keys(metadata).length > 0;
    // Track action via the pageActions API
    trackAction(action, _objectSpread(_objectSpread(_objectSpread({}, props), getBaseProps()), {}, {
      version: '',
      downstreamName: 'chat message sent'
    }), _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active',
      metadata: hasMetadata ? metadata : undefined
    }));
  }, [getBaseProps, trackAction]);
  /**
   * this action tracks the users who upload content in order to determine content is being successfully uploaded
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMeldCvGmrRAHwROauiH92e54
   * name          : studio studio content uploaded
   * downstreamName: content uploaded
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       : 1-0-0
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the user uploads content and clicks the upload button in the add media modal
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {ContentUploaded} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  var contentUploaded = (0, _react.useCallback)(function (props, options) {
    // Grab the destinations from the definition so the rudderstack reporter configures
    // the integrations accordingly
    var destinations = 'datadog,Mixpanel,Snowflake,Intercom'.split(',');
    // RudderStack unique action name for the workspace
    var action = _objectSpread({
      id: 'studio studio content uploaded'
    }, destinations && {
      destinations: destinations
    });
    var metadata = JSON.parse('{}');
    var hasMetadata = Object.keys(metadata).length > 0;
    // Track action via the pageActions API
    trackAction(action, _objectSpread(_objectSpread(_objectSpread({}, props), getBaseProps()), {}, {
      version: '1-0-0',
      downstreamName: 'content uploaded'
    }), _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active',
      metadata: hasMetadata ? metadata : undefined
    }));
  }, [getBaseProps, trackAction]);
  /**
   * this action measures the time taken in uploading a file
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio file upload
   * downstreamName: file upload
   * owner         : incognito
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : measure
   * multiStep     :  no
   * trigger       : the measurement starts when the user clicks the save button in the upload file modal and ends when the file is uploaded
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {FileUpload} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  var startFileUpload = (0, _react.useCallback)(function (props, options, callback) {
    var destinations = 'datadog,Mixpanel,Snowflake,Intercom'.split(',');
    // RudderStack unique action name for the workspace
    var action = _objectSpread({
      id: 'studio file upload'
    }, destinations && {
      destinations: destinations
    });
    measureActionsAttributesRef.current[action.id] = props;
    var metadata = JSON.parse('{}');
    var hasMetadata = Object.keys(metadata).length > 0;
    // Start measuring action via the pageActions API
    startAction(action, _objectSpread(_objectSpread({}, props), {}, {
      version: '',
      downstreamName: 'file upload'
    }), callback, _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active',
      metadata: hasMetadata ? metadata : undefined
    }));
  }, [startAction]);
  /**
   * Records action the measurement starts when the user clicks the save button in the upload file modal and ends when the file is uploaded
   */
  var endFileUpload = (0, _react.useCallback)(function (props, options) {
    var actionId = 'studio file upload';
    // Record action via the pageActions API
    endAction(actionId, _objectSpread(_objectSpread(_objectSpread({}, props), getBaseProps()), {}, {
      version: '',
      downstreamName: 'file upload'
    }), false, _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active'
    }));
  }, [getBaseProps, endAction]);
  /**
   * this action tracks the users who are adding screenshares to stage in order to better understand the quantity and how often this is occurring throughout a webinar
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMeoDxFrXC8qonY097NqfJGmz
   * name          : studio host added screenshare to stage
   * downstreamName: host added screenshare to stage
   * owner         : vikings
   * phase         : activation
   * release       : v2.0
   * version       : 1-0-0
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the host hovers over a screenshare source and clicks the "show" button
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {HostAddedScreenshareToStage} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  var hostAddedScreenshareToStage = (0, _react.useCallback)(function (props, options) {
    // Grab the destinations from the definition so the rudderstack reporter configures
    // the integrations accordingly
    var destinations = 'datadog,Mixpanel,Snowflake,Intercom'.split(',');
    // RudderStack unique action name for the workspace
    var action = _objectSpread({
      id: 'studio host added screenshare to stage'
    }, destinations && {
      destinations: destinations
    });
    var metadata = JSON.parse('{}');
    var hasMetadata = Object.keys(metadata).length > 0;
    // Track action via the pageActions API
    trackAction(action, _objectSpread(_objectSpread(_objectSpread({}, props), getBaseProps()), {}, {
      version: '1-0-0',
      downstreamName: 'host added screenshare to stage'
    }), _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active',
      metadata: hasMetadata ? metadata : undefined
    }));
  }, [getBaseProps, trackAction]);
  /**
   * this action tracks the users who enters a studio session in order to determine how many users are joining as hosts
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMekb4RhLhaEGChHWof1UI9mO
   * name          : studio host enters studio
   * downstreamName: host enters
   * owner         : quickfixjedis
   * phase         : activation
   * release       : v2.0
   * version       : 1-0-0
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the host clicks the enter the studio button on the join modal
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {HostEnters} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  var hostEnters = (0, _react.useCallback)(function (props, options) {
    // Grab the destinations from the definition so the rudderstack reporter configures
    // the integrations accordingly
    var destinations = 'datadog,Mixpanel,Snowflake,Intercom'.split(',');
    // RudderStack unique action name for the workspace
    var action = _objectSpread({
      id: 'studio host enters studio'
    }, destinations && {
      destinations: destinations
    });
    var metadata = JSON.parse('{}');
    var hasMetadata = Object.keys(metadata).length > 0;
    // Track action via the pageActions API
    trackAction(action, _objectSpread(_objectSpread(_objectSpread({}, props), getBaseProps()), {}, {
      version: '1-0-0',
      downstreamName: 'host enters'
    }), _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active',
      metadata: hasMetadata ? metadata : undefined
    }));
  }, [getBaseProps, trackAction]);
  /**
   * this action tracks the users who spotlight a source from the source tile in order to better understand which spotlight option is being used more or less
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMelWz09Eh8abbXrCYhxxxsXq
   * name          : studio host spotlights source from source tile
   * downstreamName: host spotlights source from source tile
   * owner         : quickfixjedis
   * phase         : activation
   * release       : v2.0
   * version       : 1-0-0
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the host hovers over a source on the source tile and clicks the spotlight button
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {HostSpotlightsSourceFromSourceTile} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  var hostSpotlightsSourceFromSourceTile = (0, _react.useCallback)(function (props, options) {
    // Grab the destinations from the definition so the rudderstack reporter configures
    // the integrations accordingly
    var destinations = 'datadog,Mixpanel,Snowflake,Intercom'.split(',');
    // RudderStack unique action name for the workspace
    var action = _objectSpread({
      id: 'studio host spotlights source from source tile'
    }, destinations && {
      destinations: destinations
    });
    var metadata = JSON.parse('{}');
    var hasMetadata = Object.keys(metadata).length > 0;
    // Track action via the pageActions API
    trackAction(action, _objectSpread(_objectSpread(_objectSpread({}, props), getBaseProps()), {}, {
      version: '1-0-0',
      downstreamName: 'host spotlights source from source tile'
    }), _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active',
      metadata: hasMetadata ? metadata : undefined
    }));
  }, [getBaseProps, trackAction]);
  /**
   * this action tracks the users who spotlight a source from stage in order to better understand which spotlight option is being used more or less
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMepTguwPrOo84AM6tTSsCqQv
   * name          : studio host spotlights source from stage
   * downstreamName: host spotlights source from stage
   * owner         : quickfixjedis
   * phase         : activation
   * release       : v2.0
   * version       : 1-0-0
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the host hovers over a source on stage and clicks the spotlight button
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {HostSpotlightsSourceFromStage} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  var hostSpotlightsSourceFromStage = (0, _react.useCallback)(function (props, options) {
    // Grab the destinations from the definition so the rudderstack reporter configures
    // the integrations accordingly
    var destinations = 'datadog,Mixpanel,Snowflake,Intercom'.split(',');
    // RudderStack unique action name for the workspace
    var action = _objectSpread({
      id: 'studio host spotlights source from stage'
    }, destinations && {
      destinations: destinations
    });
    var metadata = JSON.parse('{}');
    var hasMetadata = Object.keys(metadata).length > 0;
    // Track action via the pageActions API
    trackAction(action, _objectSpread(_objectSpread(_objectSpread({}, props), getBaseProps()), {}, {
      version: '1-0-0',
      downstreamName: 'host spotlights source from stage'
    }), _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active',
      metadata: hasMetadata ? metadata : undefined
    }));
  }, [getBaseProps, trackAction]);
  /**
   * this action tracks the users who started the recording(s) in order to better understand the life cycle of a recording
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio recording started workflow
   * downstreamName: recording started workflow
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the user clicks the start/startAll record button
   * destinations  : Intercom,Mixpanel,Snowflake
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {RecordingStartedWorkflow} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  var recordingStartedWorkflow = (0, _react.useCallback)(function (props, options) {
    // Grab the destinations from the definition so the rudderstack reporter configures
    // the integrations accordingly
    var destinations = 'Intercom,Mixpanel,Snowflake'.split(',');
    // RudderStack unique action name for the workspace
    var action = _objectSpread({
      id: 'studio recording started workflow'
    }, destinations && {
      destinations: destinations
    });
    var metadata = JSON.parse('{}');
    var hasMetadata = Object.keys(metadata).length > 0;
    // Track action via the pageActions API
    trackAction(action, _objectSpread(_objectSpread(_objectSpread({}, props), getBaseProps()), {}, {
      version: '',
      downstreamName: 'recording started workflow'
    }), _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active',
      metadata: hasMetadata ? metadata : undefined
    }));
  }, [getBaseProps, trackAction]);
  /**
   * this action tracks the users who started the stream(s) in order to better understand the life cycle of a stream
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio stream started workflow
   * downstreamName: stream started workflow
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the user clicks the start/startAll stream button
   * destinations  : Intercom,Mixpanel,Snowflake
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {StreamStartedWorkflow} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  var streamStartedWorkflow = (0, _react.useCallback)(function (props, options) {
    // Grab the destinations from the definition so the rudderstack reporter configures
    // the integrations accordingly
    var destinations = 'Intercom,Mixpanel,Snowflake'.split(',');
    // RudderStack unique action name for the workspace
    var action = _objectSpread({
      id: 'studio stream started workflow'
    }, destinations && {
      destinations: destinations
    });
    var metadata = JSON.parse('{}');
    var hasMetadata = Object.keys(metadata).length > 0;
    // Track action via the pageActions API
    trackAction(action, _objectSpread(_objectSpread(_objectSpread({}, props), getBaseProps()), {}, {
      version: '',
      downstreamName: 'stream started workflow'
    }), _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active',
      metadata: hasMetadata ? metadata : undefined
    }));
  }, [getBaseProps, trackAction]);
  /**
   * this action tracks the users who stopped the recording(s) in order to better understand the life cycle of a recording
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio recording stopped workflow
   * downstreamName: recording stopped workflow
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the user clicks the start/startAll record button
   * destinations  : Intercom,Mixpanel,Snowflake
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {RecordingStoppedWorkflow} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  var recordingStoppedWorkflow = (0, _react.useCallback)(function (props, options) {
    // Grab the destinations from the definition so the rudderstack reporter configures
    // the integrations accordingly
    var destinations = 'Intercom,Mixpanel,Snowflake'.split(',');
    // RudderStack unique action name for the workspace
    var action = _objectSpread({
      id: 'studio recording stopped workflow'
    }, destinations && {
      destinations: destinations
    });
    var metadata = JSON.parse('{}');
    var hasMetadata = Object.keys(metadata).length > 0;
    // Track action via the pageActions API
    trackAction(action, _objectSpread(_objectSpread(_objectSpread({}, props), getBaseProps()), {}, {
      version: '',
      downstreamName: 'recording stopped workflow'
    }), _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active',
      metadata: hasMetadata ? metadata : undefined
    }));
  }, [getBaseProps, trackAction]);
  /**
   * this action tracks the users who stopped the stream(s) in order to better understand the life cycle of a stream
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio stream stopped workflow
   * downstreamName: stream stopped workflow
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the user clicks the stop/stopAll stream button
   * destinations  : Intercom,Mixpanel,Snowflake
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {StreamStoppedWorkflow} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  var streamStoppedWorkflow = (0, _react.useCallback)(function (props, options) {
    // Grab the destinations from the definition so the rudderstack reporter configures
    // the integrations accordingly
    var destinations = 'Intercom,Mixpanel,Snowflake'.split(',');
    // RudderStack unique action name for the workspace
    var action = _objectSpread({
      id: 'studio stream stopped workflow'
    }, destinations && {
      destinations: destinations
    });
    var metadata = JSON.parse('{}');
    var hasMetadata = Object.keys(metadata).length > 0;
    // Track action via the pageActions API
    trackAction(action, _objectSpread(_objectSpread(_objectSpread({}, props), getBaseProps()), {}, {
      version: '',
      downstreamName: 'stream stopped workflow'
    }), _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active',
      metadata: hasMetadata ? metadata : undefined
    }));
  }, [getBaseProps, trackAction]);
  /**
   * this action measures the time taken in toggling a speaker camera from the source tile in order to better understand how often cameras are being toggled
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMelyGkpwBBbCk3oHu538sZ4C
   * name          : studio host toggles speaker camera from source tile
   * downstreamName: host toggles speaker camera from source tile
   * owner         : quickfixjedis
   * phase         : activation
   * release       : v2.0
   * version       : 1-0-0
   * type          : measure
   * multiStep     :  no
   * trigger       : the measurement starts when the host hovers over a source on the source tile and clicks the camera icon, and ends when the camera state change is completed
   * destinations  : Datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {HostTogglesSpeakerCameraFromSourceTile} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  var startHostTogglesSpeakerCameraFromSourceTile = (0, _react.useCallback)(function (props, options, callback) {
    var destinations = 'Datadog,Mixpanel,Snowflake,Intercom'.split(',');
    // RudderStack unique action name for the workspace
    var action = _objectSpread({
      id: 'studio host toggles speaker camera from source tile'
    }, destinations && {
      destinations: destinations
    });
    measureActionsAttributesRef.current[action.id] = props;
    var metadata = JSON.parse('{}');
    var hasMetadata = Object.keys(metadata).length > 0;
    // Start measuring action via the pageActions API
    startAction(action, _objectSpread(_objectSpread({}, props), {}, {
      version: '1-0-0',
      downstreamName: 'host toggles speaker camera from source tile'
    }), callback, _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active',
      metadata: hasMetadata ? metadata : undefined
    }));
  }, [startAction]);
  /**
   * Records action the measurement starts when the host hovers over a source on the source tile and clicks the camera icon, and ends when the camera state change is completed
   */
  var endHostTogglesSpeakerCameraFromSourceTile = (0, _react.useCallback)(function (props, options) {
    var actionId = 'studio host toggles speaker camera from source tile';
    // Record action via the pageActions API
    endAction(actionId, _objectSpread(_objectSpread(_objectSpread({}, props), getBaseProps()), {}, {
      version: '1-0-0',
      downstreamName: 'host toggles speaker camera from source tile'
    }), false, _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active'
    }));
  }, [getBaseProps, endAction]);
  /**
   * this action measures the time taken in toggling speaker source mic from the source tile in order to better understand how often mics are being toggled
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMeq6sM9IinTASO0d8uYFaTa9
   * name          : studio host toggles speaker mic from source tile
   * downstreamName: host toggles speaker mic from source tile
   * owner         : quickfixjedis
   * phase         : activation
   * release       : v2.0
   * version       : 1-0-0
   * type          : measure
   * multiStep     :  no
   * trigger       : the measurement starts when the host hovers over a source on the source tile and toggles mic, and ends when the mic state change is completed
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {HostTogglesSpeakerMicFromSourceTile} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  var startHostTogglesSpeakerMicFromSourceTile = (0, _react.useCallback)(function (props, options, callback) {
    var destinations = 'datadog,Mixpanel,Snowflake,Intercom'.split(',');
    // RudderStack unique action name for the workspace
    var action = _objectSpread({
      id: 'studio host toggles speaker mic from source tile'
    }, destinations && {
      destinations: destinations
    });
    measureActionsAttributesRef.current[action.id] = props;
    var metadata = JSON.parse('{}');
    var hasMetadata = Object.keys(metadata).length > 0;
    // Start measuring action via the pageActions API
    startAction(action, _objectSpread(_objectSpread({}, props), {}, {
      version: '1-0-0',
      downstreamName: 'host toggles speaker mic from source tile'
    }), callback, _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active',
      metadata: hasMetadata ? metadata : undefined
    }));
  }, [startAction]);
  /**
   * Records action the measurement starts when the host hovers over a source on the source tile and toggles mic, and ends when the mic state change is completed
   */
  var endHostTogglesSpeakerMicFromSourceTile = (0, _react.useCallback)(function (props, options) {
    var actionId = 'studio host toggles speaker mic from source tile';
    // Record action via the pageActions API
    endAction(actionId, _objectSpread(_objectSpread(_objectSpread({}, props), getBaseProps()), {}, {
      version: '1-0-0',
      downstreamName: 'host toggles speaker mic from source tile'
    }), false, _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active'
    }));
  }, [getBaseProps, endAction]);
  /**
   * this action measures the time taken in loading studio chat
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio load chat
   * downstreamName: load chat
   * owner         : vikings
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : measure
   * multiStep     :  no
   * trigger       : the measurement starts when chat opens and ends when the channel is created and attendee joins
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {LoadChat} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  var startLoadChat = (0, _react.useCallback)(function (props, options, callback) {
    var destinations = 'datadog,Mixpanel,Snowflake,Intercom'.split(',');
    // RudderStack unique action name for the workspace
    var action = _objectSpread({
      id: 'studio load chat'
    }, destinations && {
      destinations: destinations
    });
    measureActionsAttributesRef.current[action.id] = props;
    var metadata = JSON.parse('{}');
    var hasMetadata = Object.keys(metadata).length > 0;
    // Start measuring action via the pageActions API
    startAction(action, _objectSpread(_objectSpread({}, props), {}, {
      version: '',
      downstreamName: 'load chat'
    }), callback, _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active',
      metadata: hasMetadata ? metadata : undefined
    }));
  }, [startAction]);
  /**
   * Records action the measurement starts when chat opens and ends when the channel is created and attendee joins
   */
  var endLoadChat = (0, _react.useCallback)(function (props, options) {
    var actionId = 'studio load chat';
    // Record action via the pageActions API
    endAction(actionId, _objectSpread(_objectSpread(_objectSpread({}, props), getBaseProps()), {}, {
      version: '',
      downstreamName: 'load chat'
    }), false, _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active'
    }));
  }, [getBaseProps, endAction]);
  /**
   * this action measures the time taken in loading the readiness checker, creation of sandbox meeting and adding of attendee to the meeting
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio load readiness checker
   * downstreamName: load readiness checker
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : measure
   * multiStep     :  no
   * trigger       : the measurement starts when readiness checker opens and ends when sandbox meeting is created and attendee is added to the meeting
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {LoadReadinessChecker} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  var startLoadReadinessChecker = (0, _react.useCallback)(function (props, options, callback) {
    var destinations = 'datadog,Mixpanel,Snowflake,Intercom'.split(',');
    // RudderStack unique action name for the workspace
    var action = _objectSpread({
      id: 'studio load readiness checker'
    }, destinations && {
      destinations: destinations
    });
    measureActionsAttributesRef.current[action.id] = props;
    var metadata = JSON.parse('{}');
    var hasMetadata = Object.keys(metadata).length > 0;
    // Start measuring action via the pageActions API
    startAction(action, _objectSpread(_objectSpread({}, props), {}, {
      version: '',
      downstreamName: 'load readiness checker'
    }), callback, _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active',
      metadata: hasMetadata ? metadata : undefined
    }));
  }, [startAction]);
  /**
   * Records action the measurement starts when readiness checker opens and ends when sandbox meeting is created and attendee is added to the meeting
   */
  var endLoadReadinessChecker = (0, _react.useCallback)(function (props, options) {
    var actionId = 'studio load readiness checker';
    // Record action via the pageActions API
    endAction(actionId, _objectSpread(_objectSpread(_objectSpread({}, props), getBaseProps()), {}, {
      version: '',
      downstreamName: 'load readiness checker'
    }), false, _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active'
    }));
  }, [getBaseProps, endAction]);
  /**
   * this action tracks the users who clicked on the media controls on stage in order to know what type of media action was performed by the host
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio media playback changed
   * downstreamName: media playback changed
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the host uses the media controls on stage
   * destinations  : datadog,Mixpanel,Snowflake
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {MediaPlaybackChanged} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  var mediaPlaybackChanged = (0, _react.useCallback)(function (props, options) {
    // Grab the destinations from the definition so the rudderstack reporter configures
    // the integrations accordingly
    var destinations = 'datadog,Mixpanel,Snowflake'.split(',');
    // RudderStack unique action name for the workspace
    var action = _objectSpread({
      id: 'studio media playback changed'
    }, destinations && {
      destinations: destinations
    });
    var metadata = JSON.parse('{}');
    var hasMetadata = Object.keys(metadata).length > 0;
    // Track action via the pageActions API
    trackAction(action, _objectSpread(_objectSpread(_objectSpread({}, props), getBaseProps()), {}, {
      version: '',
      downstreamName: 'media playback changed'
    }), _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active',
      metadata: hasMetadata ? metadata : undefined
    }));
  }, [getBaseProps, trackAction]);
  /**
   * this action measures the time taken in director lite application to get loaded till the chime meeting creation
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMeny4usepwA0m0rUkS7YjjNP
   * name          : studio meeting as host
   * downstreamName: meeting as host
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       : 1-0-0
   * type          : measure
   * multiStep     :  no
   * trigger       : the measurement starts when the application started for chime meeting creation and ends when the chime meeting got created
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {MeetingAsHost} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  var startMeetingAsHost = (0, _react.useCallback)(function (props, options, callback) {
    var destinations = 'datadog,Mixpanel,Snowflake,Intercom'.split(',');
    // RudderStack unique action name for the workspace
    var action = _objectSpread({
      id: 'studio meeting as host'
    }, destinations && {
      destinations: destinations
    });
    measureActionsAttributesRef.current[action.id] = props;
    var metadata = JSON.parse('{}');
    var hasMetadata = Object.keys(metadata).length > 0;
    // Start measuring action via the pageActions API
    startAction(action, _objectSpread(_objectSpread({}, props), {}, {
      version: '1-0-0',
      downstreamName: 'meeting as host'
    }), callback, _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active',
      metadata: hasMetadata ? metadata : undefined
    }));
  }, [startAction]);
  /**
   * Records action the measurement starts when the application started for chime meeting creation and ends when the chime meeting got created
   */
  var endMeetingAsHost = (0, _react.useCallback)(function (props, options) {
    var actionId = 'studio meeting as host';
    // Record action via the pageActions API
    endAction(actionId, _objectSpread(_objectSpread(_objectSpread({}, props), getBaseProps()), {}, {
      version: '1-0-0',
      downstreamName: 'meeting as host'
    }), false, _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active'
    }));
  }, [getBaseProps, endAction]);
  /**
   * This action tracks the users who change their microphone in order to use different audio source.
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio microphone changed
   * downstreamName: microphone changed
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the user toggles their microphone
   * destinations  : datadog,Mixpanel,Snowflake
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {MicrophoneChanged} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  var microphoneChanged = (0, _react.useCallback)(function (props, options) {
    // Grab the destinations from the definition so the rudderstack reporter configures
    // the integrations accordingly
    var destinations = 'datadog,Mixpanel,Snowflake'.split(',');
    // RudderStack unique action name for the workspace
    var action = _objectSpread({
      id: 'studio microphone changed'
    }, destinations && {
      destinations: destinations
    });
    var metadata = JSON.parse('{}');
    var hasMetadata = Object.keys(metadata).length > 0;
    // Track action via the pageActions API
    trackAction(action, _objectSpread(_objectSpread(_objectSpread({}, props), getBaseProps()), {}, {
      version: '',
      downstreamName: 'microphone changed'
    }), _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active',
      metadata: hasMetadata ? metadata : undefined
    }));
  }, [getBaseProps, trackAction]);
  /**
   * This action measures the time taken in toggling the speaker's microphone on or off to understand responsiveness and user behavior.
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio microphone toggled
   * downstreamName: microphone toggled
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : measure
   * multiStep     :  no
   * trigger       : the measurement starts when the speaker clicks the mute/unmute button to toggle their microphone, and ends when the microphone state change (ON/OFF) is completed and reflected in the UI
   * destinations  : datadog,Mixpanel,Snowflake
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {MicrophoneToggled} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  var startMicrophoneToggled = (0, _react.useCallback)(function (props, options, callback) {
    var destinations = 'datadog,Mixpanel,Snowflake'.split(',');
    // RudderStack unique action name for the workspace
    var action = _objectSpread({
      id: 'studio microphone toggled'
    }, destinations && {
      destinations: destinations
    });
    measureActionsAttributesRef.current[action.id] = props;
    var metadata = JSON.parse('{}');
    var hasMetadata = Object.keys(metadata).length > 0;
    // Start measuring action via the pageActions API
    startAction(action, _objectSpread(_objectSpread({}, props), {}, {
      version: '',
      downstreamName: 'microphone toggled'
    }), callback, _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active',
      metadata: hasMetadata ? metadata : undefined
    }));
  }, [startAction]);
  /**
   * Records action the measurement starts when the speaker clicks the mute/unmute button to toggle their microphone, and ends when the microphone state change (ON/OFF) is completed and reflected in the UI
   */
  var endMicrophoneToggled = (0, _react.useCallback)(function (props, options) {
    var actionId = 'studio microphone toggled';
    // Record action via the pageActions API
    endAction(actionId, _objectSpread(_objectSpread(_objectSpread({}, props), getBaseProps()), {}, {
      version: '',
      downstreamName: 'microphone toggled'
    }), false, _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active'
    }));
  }, [getBaseProps, endAction]);
  /**
   * this action measures the time taken in presenter getting added to a chime meeting.
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMekRHdCvCEm0GKbgq1JDMFpR
   * name          : studio presenter added to chime meeting
   * downstreamName: presenter added to chime meeting
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       : 1-0-0
   * type          : measure
   * multiStep     :  no
   * trigger       : the measurement starts when host accepts the knock request and ends when presenter is added to chime meeting successfully
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {PresenterAddedToChimeMeeting} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  var startPresenterAddedToChimeMeeting = (0, _react.useCallback)(function (props, options, callback) {
    var destinations = 'datadog,Mixpanel,Snowflake,Intercom'.split(',');
    // RudderStack unique action name for the workspace
    var action = _objectSpread({
      id: 'studio presenter added to chime meeting'
    }, destinations && {
      destinations: destinations
    });
    measureActionsAttributesRef.current[action.id] = props;
    var metadata = JSON.parse('{}');
    var hasMetadata = Object.keys(metadata).length > 0;
    // Start measuring action via the pageActions API
    startAction(action, _objectSpread(_objectSpread({}, props), {}, {
      version: '1-0-0',
      downstreamName: 'presenter added to chime meeting'
    }), callback, _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active',
      metadata: hasMetadata ? metadata : undefined
    }));
  }, [startAction]);
  /**
   * Records action the measurement starts when host accepts the knock request and ends when presenter is added to chime meeting successfully
   */
  var endPresenterAddedToChimeMeeting = (0, _react.useCallback)(function (props, options) {
    var actionId = 'studio presenter added to chime meeting';
    // Record action via the pageActions API
    endAction(actionId, _objectSpread(_objectSpread(_objectSpread({}, props), getBaseProps()), {}, {
      version: '1-0-0',
      downstreamName: 'presenter added to chime meeting'
    }), false, _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active'
    }));
  }, [getBaseProps, endAction]);
  /**
   * this action tracks the users who send the request in order to share their screen.
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio screen share request sent
   * downstreamName: screen share request sent
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the speaker sends the request to share their screen by clicking on the share screen button on the presenter studio page
   * destinations  : datadog,Mixpanel,Snowflake
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {ScreenShareRequestSent} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  var screenShareRequestSent = (0, _react.useCallback)(function (props, options) {
    // Grab the destinations from the definition so the rudderstack reporter configures
    // the integrations accordingly
    var destinations = 'datadog,Mixpanel,Snowflake'.split(',');
    // RudderStack unique action name for the workspace
    var action = _objectSpread({
      id: 'studio screen share request sent'
    }, destinations && {
      destinations: destinations
    });
    var metadata = JSON.parse('{}');
    var hasMetadata = Object.keys(metadata).length > 0;
    // Track action via the pageActions API
    trackAction(action, _objectSpread(_objectSpread(_objectSpread({}, props), getBaseProps()), {}, {
      version: '',
      downstreamName: 'screen share request sent'
    }), _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active',
      metadata: hasMetadata ? metadata : undefined
    }));
  }, [getBaseProps, trackAction]);
  /**
   * this action measures the time taken in starting screen share
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio screen share started
   * downstreamName: screen share started
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : measure
   * multiStep     :  no
   * trigger       : the measurement starts when the screen share request is submitted to SDK, and ends when the screen share request has completed
   * destinations  : datadog,Mixpanel,Snowflake
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {ScreenShareStarted} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  var startScreenShareStarted = (0, _react.useCallback)(function (props, options, callback) {
    var destinations = 'datadog,Mixpanel,Snowflake'.split(',');
    // RudderStack unique action name for the workspace
    var action = _objectSpread({
      id: 'studio screen share started'
    }, destinations && {
      destinations: destinations
    });
    measureActionsAttributesRef.current[action.id] = props;
    var metadata = JSON.parse('{}');
    var hasMetadata = Object.keys(metadata).length > 0;
    // Start measuring action via the pageActions API
    startAction(action, _objectSpread(_objectSpread({}, props), {}, {
      version: '',
      downstreamName: 'screen share started'
    }), callback, _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active',
      metadata: hasMetadata ? metadata : undefined
    }));
  }, [startAction]);
  /**
   * Records action the measurement starts when the screen share request is submitted to SDK, and ends when the screen share request has completed
   */
  var endScreenShareStarted = (0, _react.useCallback)(function (props, options) {
    var actionId = 'studio screen share started';
    // Record action via the pageActions API
    endAction(actionId, _objectSpread(_objectSpread(_objectSpread({}, props), getBaseProps()), {}, {
      version: '',
      downstreamName: 'screen share started'
    }), false, _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active'
    }));
  }, [getBaseProps, endAction]);
  /**
   * this action tracks the users who stopped sharing their screen in order to know when user stops sharing their screen
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio screen share stopped
   * downstreamName: screen share stopped
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the user stops sharing their screen
   * destinations  : datadog,Mixpanel,Snowflake
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {ScreenShareStopped} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  var screenShareStopped = (0, _react.useCallback)(function (props, options) {
    // Grab the destinations from the definition so the rudderstack reporter configures
    // the integrations accordingly
    var destinations = 'datadog,Mixpanel,Snowflake'.split(',');
    // RudderStack unique action name for the workspace
    var action = _objectSpread({
      id: 'studio screen share stopped'
    }, destinations && {
      destinations: destinations
    });
    var metadata = JSON.parse('{}');
    var hasMetadata = Object.keys(metadata).length > 0;
    // Track action via the pageActions API
    trackAction(action, _objectSpread(_objectSpread(_objectSpread({}, props), getBaseProps()), {}, {
      version: '',
      downstreamName: 'screen share stopped'
    }), _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active',
      metadata: hasMetadata ? metadata : undefined
    }));
  }, [getBaseProps, trackAction]);
  /**
   * this action tracks the users who enter the studio after knock is approved in order to understand speaker experience joining the studio
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMek6vGle76DdjtYLbpUWbh0D
   * name          : studio speaker enters studio
   * downstreamName: speaker enters
   * owner         : quickfixjedis
   * phase         : activation
   * release       : v2.0
   * version       : 1-0-0
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the user clicks the enter the studio button on the final join modal
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {SpeakerEnters} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  var speakerEnters = (0, _react.useCallback)(function (props, options) {
    // Grab the destinations from the definition so the rudderstack reporter configures
    // the integrations accordingly
    var destinations = 'datadog,Mixpanel,Snowflake,Intercom'.split(',');
    // RudderStack unique action name for the workspace
    var action = _objectSpread({
      id: 'studio speaker enters studio'
    }, destinations && {
      destinations: destinations
    });
    var metadata = JSON.parse('{}');
    var hasMetadata = Object.keys(metadata).length > 0;
    // Track action via the pageActions API
    trackAction(action, _objectSpread(_objectSpread(_objectSpread({}, props), getBaseProps()), {}, {
      version: '1-0-0',
      downstreamName: 'speaker enters'
    }), _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active',
      metadata: hasMetadata ? metadata : undefined
    }));
  }, [getBaseProps, trackAction]);
  /**
   * This action tracks the users who change their viewing mode in order to view the speaker studio page in either minimize or expand mode.
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio speaker view changed
   * downstreamName: speaker view changed
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the speaker either clicks on Expand or Minimize button in the speaker studio page
   * destinations  : datadog,Mixpanel,Snowflake
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {SpeakerViewChanged} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  var speakerViewChanged = (0, _react.useCallback)(function (props, options) {
    // Grab the destinations from the definition so the rudderstack reporter configures
    // the integrations accordingly
    var destinations = 'datadog,Mixpanel,Snowflake'.split(',');
    // RudderStack unique action name for the workspace
    var action = _objectSpread({
      id: 'studio speaker view changed'
    }, destinations && {
      destinations: destinations
    });
    var metadata = JSON.parse('{}');
    var hasMetadata = Object.keys(metadata).length > 0;
    // Track action via the pageActions API
    trackAction(action, _objectSpread(_objectSpread(_objectSpread({}, props), getBaseProps()), {}, {
      version: '',
      downstreamName: 'speaker view changed'
    }), _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active',
      metadata: hasMetadata ? metadata : undefined
    }));
  }, [getBaseProps, trackAction]);
  /**
   * this action measures the time taken in the start all stream operation
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio start all streams
   * downstreamName: start all streams
   * owner         : incognito
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : measure
   * multiStep     :  no
   * trigger       : the measurement starts when the host clicks on the startAll stream button and ends when all the streams have either started or failed
   * destinations  : datadog,Mixpanel
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {StartAllStreams} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  var startStartAllStreams = (0, _react.useCallback)(function (props, options, callback) {
    var destinations = 'datadog,Mixpanel'.split(',');
    // RudderStack unique action name for the workspace
    var action = _objectSpread({
      id: 'studio start all streams'
    }, destinations && {
      destinations: destinations
    });
    measureActionsAttributesRef.current[action.id] = props;
    var metadata = JSON.parse('{}');
    var hasMetadata = Object.keys(metadata).length > 0;
    // Start measuring action via the pageActions API
    startAction(action, _objectSpread(_objectSpread({}, props), {}, {
      version: '',
      downstreamName: 'start all streams'
    }), callback, _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active',
      metadata: hasMetadata ? metadata : undefined
    }));
  }, [startAction]);
  /**
   * Records action the measurement starts when the host clicks on the startAll stream button and ends when all the streams have either started or failed
   */
  var endStartAllStreams = (0, _react.useCallback)(function (props, options) {
    var actionId = 'studio start all streams';
    // Record action via the pageActions API
    endAction(actionId, _objectSpread(_objectSpread(_objectSpread({}, props), getBaseProps()), {}, {
      version: '',
      downstreamName: 'start all streams'
    }), false, _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active'
    }));
  }, [getBaseProps, endAction]);
  /**
   * this action tracks the users who use our stock content for their webinar in order to see how often they are used
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMejtXyCXQZMPvJsQLGazMfSS
   * name          : studio stock content used
   * downstreamName: stock content used
   * owner         : quickfixjedis
   * phase         : activation
   * release       : v2.0
   * version       : 1-0-0
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the user selects stock content and clicks save button
   * destinations  : Datadog,Mixpanel,Intercom,Snowflake
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {StockContentUsed} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  var stockContentUsed = (0, _react.useCallback)(function (props, options) {
    // Grab the destinations from the definition so the rudderstack reporter configures
    // the integrations accordingly
    var destinations = 'Datadog,Mixpanel,Intercom,Snowflake'.split(',');
    // RudderStack unique action name for the workspace
    var action = _objectSpread({
      id: 'studio stock content used'
    }, destinations && {
      destinations: destinations
    });
    var metadata = JSON.parse('{}');
    var hasMetadata = Object.keys(metadata).length > 0;
    // Track action via the pageActions API
    trackAction(action, _objectSpread(_objectSpread(_objectSpread({}, props), getBaseProps()), {}, {
      version: '1-0-0',
      downstreamName: 'stock content used'
    }), _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active',
      metadata: hasMetadata ? metadata : undefined
    }));
  }, [getBaseProps, trackAction]);
  /**
   * this action measures the time taken in starting the stream
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio stream start lifecycle
   * downstreamName: stream start lifecycle
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : measure
   * multiStep     :  no
   * trigger       : the measurement starts when the user click on the start/startAll stream button and ends when the streaming is started or failed in starting
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {StreamStartLifecycle} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  var startStreamStartLifecycle = (0, _react.useCallback)(function (props, options, callback) {
    var destinations = 'datadog,Mixpanel,Snowflake,Intercom'.split(',');
    // RudderStack unique action name for the workspace
    var action = _objectSpread({
      id: 'studio stream start lifecycle'
    }, destinations && {
      destinations: destinations
    });
    measureActionsAttributesRef.current[action.id] = props;
    var metadata = JSON.parse('{}');
    var hasMetadata = Object.keys(metadata).length > 0;
    // Start measuring action via the pageActions API
    startAction(action, _objectSpread(_objectSpread({}, props), {}, {
      version: '',
      downstreamName: 'stream start lifecycle'
    }), callback, _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active',
      metadata: hasMetadata ? metadata : undefined
    }));
  }, [startAction]);
  /**
   * Records action the measurement starts when the user click on the start/startAll stream button and ends when the streaming is started or failed in starting
   */
  var endStreamStartLifecycle = (0, _react.useCallback)(function (props, options) {
    var actionId = 'studio stream start lifecycle';
    // Record action via the pageActions API
    endAction(actionId, _objectSpread(_objectSpread(_objectSpread({}, props), getBaseProps()), {}, {
      version: '',
      downstreamName: 'stream start lifecycle'
    }), false, _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active'
    }));
  }, [getBaseProps, endAction]);
  /**
   * this action measures the time taken in stopping the stream
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio stream stop lifecycle
   * downstreamName: stream stop lifecycle
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : measure
   * multiStep     :  no
   * trigger       : the measurement starts when the user click on the stop/stopAll stream button and ends when the streaming is stopped or failed in stopping
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {StreamStopLifecycle} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  var startStreamStopLifecycle = (0, _react.useCallback)(function (props, options, callback) {
    var destinations = 'datadog,Mixpanel,Snowflake,Intercom'.split(',');
    // RudderStack unique action name for the workspace
    var action = _objectSpread({
      id: 'studio stream stop lifecycle'
    }, destinations && {
      destinations: destinations
    });
    measureActionsAttributesRef.current[action.id] = props;
    var metadata = JSON.parse('{}');
    var hasMetadata = Object.keys(metadata).length > 0;
    // Start measuring action via the pageActions API
    startAction(action, _objectSpread(_objectSpread({}, props), {}, {
      version: '',
      downstreamName: 'stream stop lifecycle'
    }), callback, _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active',
      metadata: hasMetadata ? metadata : undefined
    }));
  }, [startAction]);
  /**
   * Records action the measurement starts when the user click on the stop/stopAll stream button and ends when the streaming is stopped or failed in stopping
   */
  var endStreamStopLifecycle = (0, _react.useCallback)(function (props, options) {
    var actionId = 'studio stream stop lifecycle';
    // Record action via the pageActions API
    endAction(actionId, _objectSpread(_objectSpread(_objectSpread({}, props), getBaseProps()), {}, {
      version: '',
      downstreamName: 'stream stop lifecycle'
    }), false, _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active'
    }));
  }, [getBaseProps, endAction]);
  /**
   * This action tracks the users who clicks on test audio button in order to test their audio setup
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio test audio button clicked
   * downstreamName: test audio button clicked
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the user tests their audio by clicking the test audio button
   * destinations  : datadog,Mixpanel,Snowflake
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {TestAudioButtonClicked} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  var testAudioButtonClicked = (0, _react.useCallback)(function (props, options) {
    // Grab the destinations from the definition so the rudderstack reporter configures
    // the integrations accordingly
    var destinations = 'datadog,Mixpanel,Snowflake'.split(',');
    // RudderStack unique action name for the workspace
    var action = _objectSpread({
      id: 'studio test audio button clicked'
    }, destinations && {
      destinations: destinations
    });
    var metadata = JSON.parse('{}');
    var hasMetadata = Object.keys(metadata).length > 0;
    // Track action via the pageActions API
    trackAction(action, _objectSpread(_objectSpread(_objectSpread({}, props), getBaseProps()), {}, {
      version: '',
      downstreamName: 'test audio button clicked'
    }), _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active',
      metadata: hasMetadata ? metadata : undefined
    }));
  }, [getBaseProps, trackAction]);
  /**
   * this action tracks the users who as presenter share screen in order to determine screen share total is working fine
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMeo6kDKYM3TAQr5HBGjykkKw
   * name          : studio total screen share
   * downstreamName: total screen share
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       : 1-0-0
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the user shares the screen and see the total count of share screen
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {TotalScreenShare} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  var totalScreenShare = (0, _react.useCallback)(function (props, options) {
    // Grab the destinations from the definition so the rudderstack reporter configures
    // the integrations accordingly
    var destinations = 'datadog,Mixpanel,Snowflake,Intercom'.split(',');
    // RudderStack unique action name for the workspace
    var action = _objectSpread({
      id: 'studio total screen share'
    }, destinations && {
      destinations: destinations
    });
    var metadata = JSON.parse('{}');
    var hasMetadata = Object.keys(metadata).length > 0;
    // Track action via the pageActions API
    trackAction(action, _objectSpread(_objectSpread(_objectSpread({}, props), getBaseProps()), {}, {
      version: '1-0-0',
      downstreamName: 'total screen share'
    }), _objectSpread(_objectSpread({}, options), {}, {
      trackingPlanName: trackingPlanName,
      status: 'active',
      metadata: hasMetadata ? metadata : undefined
    }));
  }, [getBaseProps, trackAction]);
  return {
    backgroundUploaded: backgroundUploaded,
    startBackgroundUploadedOnStage: startBackgroundUploadedOnStage,
    endBackgroundUploadedOnStage: endBackgroundUploadedOnStage,
    cameraChanged: cameraChanged,
    startCameraToggled: startCameraToggled,
    endCameraToggled: endCameraToggled,
    chatMessageSent: chatMessageSent,
    contentUploaded: contentUploaded,
    startFileUpload: startFileUpload,
    endFileUpload: endFileUpload,
    hostAddedScreenshareToStage: hostAddedScreenshareToStage,
    hostEnters: hostEnters,
    hostSpotlightsSourceFromSourceTile: hostSpotlightsSourceFromSourceTile,
    hostSpotlightsSourceFromStage: hostSpotlightsSourceFromStage,
    recordingStartedWorkflow: recordingStartedWorkflow,
    streamStartedWorkflow: streamStartedWorkflow,
    recordingStoppedWorkflow: recordingStoppedWorkflow,
    streamStoppedWorkflow: streamStoppedWorkflow,
    startHostTogglesSpeakerCameraFromSourceTile: startHostTogglesSpeakerCameraFromSourceTile,
    endHostTogglesSpeakerCameraFromSourceTile: endHostTogglesSpeakerCameraFromSourceTile,
    startHostTogglesSpeakerMicFromSourceTile: startHostTogglesSpeakerMicFromSourceTile,
    endHostTogglesSpeakerMicFromSourceTile: endHostTogglesSpeakerMicFromSourceTile,
    startLoadChat: startLoadChat,
    endLoadChat: endLoadChat,
    startLoadReadinessChecker: startLoadReadinessChecker,
    endLoadReadinessChecker: endLoadReadinessChecker,
    mediaPlaybackChanged: mediaPlaybackChanged,
    startMeetingAsHost: startMeetingAsHost,
    endMeetingAsHost: endMeetingAsHost,
    microphoneChanged: microphoneChanged,
    startMicrophoneToggled: startMicrophoneToggled,
    endMicrophoneToggled: endMicrophoneToggled,
    startPresenterAddedToChimeMeeting: startPresenterAddedToChimeMeeting,
    endPresenterAddedToChimeMeeting: endPresenterAddedToChimeMeeting,
    screenShareRequestSent: screenShareRequestSent,
    startScreenShareStarted: startScreenShareStarted,
    endScreenShareStarted: endScreenShareStarted,
    screenShareStopped: screenShareStopped,
    speakerEnters: speakerEnters,
    speakerViewChanged: speakerViewChanged,
    startStartAllStreams: startStartAllStreams,
    endStartAllStreams: endStartAllStreams,
    stockContentUsed: stockContentUsed,
    startStreamStartLifecycle: startStreamStartLifecycle,
    endStreamStartLifecycle: endStreamStartLifecycle,
    startStreamStopLifecycle: startStreamStopLifecycle,
    endStreamStopLifecycle: endStreamStopLifecycle,
    testAudioButtonClicked: testAudioButtonClicked,
    totalScreenShare: totalScreenShare
  };
};